// ============================================================
// Indikatoren — ATR (Wilder) aus den Chart-Bars.
// ============================================================
import { Bar } from './types';

// Wilder-ATR über `period` aus den letzten Bars. Liefert null bei zu wenig Daten.
export function atr(bars: Bar[], period: number): number | null {
  if (bars.length < period + 1) return null;
  const trs: number[] = [];
  for (let i = 1; i < bars.length; i++) {
    const h = bars[i].h, l = bars[i].l, pc = bars[i - 1].c;
    trs.push(Math.max(h - l, Math.abs(h - pc), Math.abs(l - pc)));
  }
  // Wilder-Glättung: erster Wert = SMA der ersten `period` TRs, dann rekursiv.
  let a = trs.slice(0, period).reduce((s, v) => s + v, 0) / period;
  for (let i = period; i < trs.length; i++) {
    a = (a * (period - 1) + trs[i]) / period;
  }
  return a;
}
